module.exports = __webpack_public_path__ + "static/anglais-2b47ec212d6e39a6438d7ce3a44f98df.jpg";